export default "__VITE_ASSET__CL51yKWY__"